/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AddUpdateJobYieldModal_job$ref: FragmentReference;
declare export opaque type AddUpdateJobYieldModal_job$fragmentType: AddUpdateJobYieldModal_job$ref;
export type AddUpdateJobYieldModal_job = {|
  +id: string,
  +order: ?{|
    +id: string,
    +orderNumber: string,
  |},
  +workflow: {|
    +id: string,
    +states: $ReadOnlyArray<{|
      +id: string,
      +isGangRun: ?boolean,
    |}>,
  |},
  +$refType: AddUpdateJobYieldModal_job$ref,
|};
export type AddUpdateJobYieldModal_job$data = AddUpdateJobYieldModal_job;
export type AddUpdateJobYieldModal_job$key = {
  +$data?: AddUpdateJobYieldModal_job$data,
  +$fragmentRefs: AddUpdateJobYieldModal_job$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "AddUpdateJobYieldModal_job",
  "type": "Job",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "order",
      "storageKey": null,
      "args": null,
      "concreteType": "Order",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "orderNumber",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "workflow",
      "storageKey": null,
      "args": null,
      "concreteType": "Workflow",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "states",
          "storageKey": null,
          "args": null,
          "concreteType": "WorkflowState",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isGangRun",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ff3cce97890a15b0a84924d533e02932';
module.exports = node;
